module.exports = __webpack_public_path__ + "img/tenor(10).gif";